// src/pages/services/TimeChainage.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './TimeChainage.module.css';

const TimeChainage = () => {
  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <h1 className={styles.heroTitle}>Time–Chainage Diagram Development</h1>
        <p className={styles.heroText}>
          Transform linear project complexity into <strong>clear, actionable visuals</strong> — powered by industry-leading tools and expert insight.
        </p>
        <Link to="/contact" className={styles.heroButton}>
          Request a Demo
        </Link>
      </section>

      {/* Intro & Services Section */}
      <section className={styles.section}>
        <div className={styles.contentContainer}>
          <p className={styles.introText}>
            Nulek Consulting specialise in producing high-quality Time–Chainage diagrams using industry-leading software such as TILOS and Turbo-Chart. These visual scheduling tools are essential for linear and infrastructure projects, providing clear, intuitive, and geographically aligned representations of project activities.
          </p>
          <p className={styles.introTextSecondary}>
            Our diagrams help project teams, contractors, and stakeholders understand construction sequencing, access constraints, and production rates—all in a single, powerful visual.
          </p>

          <h2 className={styles.sectionTitle}>Our Time–Chainage Services</h2>

          <ul className={styles.serviceList}>
            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Time Chainage Diagram Creation</h3>
              <p className={styles.serviceDesc}>
                Development of high-fidelity, geospatially accurate diagrams that map activities along linear assets (e.g., roads, rail, pipelines), integrating location, duration, and resource data.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Linear Project Planning</h3>
              <p className={styles.serviceDesc}>
                Structuring project execution around linear constraints — including staging, access windows, utility corridors, and environmental approvals — to optimise sequencing and resource flow.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Schedule Integration and Data Modelling</h3>
              <p className={styles.serviceDesc}>
                Seamless linkage with Primavera P6 or MS Project schedules to ensure time-chainage visuals remain synchronised with master programme logic and updates.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Scenario, Staging and Access Modelling</h3>
              <p className={styles.serviceDesc}>
                Visual comparison of alternative delivery strategies — such as night works, staged closures, or parallel workfronts — to support decision-making and stakeholder engagement.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Progress Time Chainage Updates</h3>
              <p className={styles.serviceDesc}>
                Real-time or periodic updates reflecting actual progress, forecast trends, and lookahead activities — enabling proactive issue identification and communication.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Reporting & Communication</h3>
              <p className={styles.serviceDesc}>
                Customised visual reports for executive briefings, community engagement, regulatory submissions, and site-level coordination — turning complex data into compelling narratives.
              </p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TimeChainage;